<ng-container *ngIf="integrations$ | async"></ng-container>

<div class="course-archive-pause-integration-list">
  <scaffold-dialog
    title="Pause Integration"
    fit="true"
    size="'half'"
    buttonsFlexEnd="true"
    showCloseButton="true"
    (close)="close()"
  >
    <div scaffoldDialogBody>
      <ng-container *ngIf="isLoading; else loaded">
        <div class="course-archive-pause-integration-list-loading-container">
          <i class="fas fa-spinner fa-spin" style="font-size: 27px"></i>
        </div>
      </ng-container>
      <ng-template #loaded>
        <div
          *ngIf="hasError; else list"
          class="course-archive-pause-integration-list-error-loading error-color"
        >
          Error Loading Integrations at this time.
        </div>
        <ng-template #list>
          <ul class="course-archive-pause-integration-list-items">
            <li
              *ngFor="let integration of integrations"
              class="course-archive-pause-integration-list-item"
            >
              <div class="course-archive-pause-integration-list-item-title">
                {{ integration.friendly_name||integration.name }}
              </div>
              <div
                class="course-archive-pause-integration-list-item-button-wrapper"
              >
                <button
                  (click)="updateIntegrationPauseState(integration)"
                  nbButton
                  ghost
                  [disabled]="integration.isUpdating"
                  class="course-archive-pause-integration-list-item-button"
                >
                  <ng-container *ngIf="!integration.paused">
                    <span class="text-link-color">
                      <i class="fa-light fa-circle-pause"></i>
                    </span>
                    <span
                      class="course-archive-pause-integration-list-item-button-text"
                    >
                      Pause Archive
                    </span>
                  </ng-container>

                  <ng-container *ngIf="integration.paused">
                    <span class="text-link-color">
                      <i class="fa-light fa-circle-play"></i>
                    </span>
                    <span
                      class="course-archive-pause-integration-list-item-button-text"
                    >
                      Resume Archive
                    </span>
                  </ng-container>
                </button>
              </div>
            </li>
          </ul>
        </ng-template>
      </ng-template>
    </div>
    <div scaffoldDialogButtons>
      <button
        (click)="close()"
        class="course-archive-pause-integration-list-close-button"
        nbButton
        status="primary"
      >
        Done
      </button>
    </div>
  </scaffold-dialog>
</div>
